import { DynamicConfig } from '@statsig/js-client';

import { Injectable } from '@angular/core';
import { Router } from '@angular/router';

import { StatsigService } from '@services/statsig.service';

interface IDebounceTime {
  [route: string]: number;
}

export const CONFIG_NAME = 'debounce-time';

@Injectable({ providedIn: 'root' })
export class DebounceTimeConfig {
  private _config: DynamicConfig;

  public get config(): IDebounceTime {
    return this._config.value as IDebounceTime;
  }

  constructor(
    private statsigService: StatsigService,
    private router: Router,
  ) {
    this._config = this.statsigService.evaluateDynamicConfig(CONFIG_NAME);
  }

  public getDebounceTime(): number {
    const debounceTimeKey = Object.keys(this.config).find(key => this.router.url.indexOf(key) !== -1);

    if (!debounceTimeKey) return;
    return this.config[debounceTimeKey];
  }
}
